module.exports = __webpack_public_path__ + "img/pinguinitos-bg.5881b6d8.svg";